import { Component, input, output } from '@angular/core';
import { ButtonComponent, ButtonSize, ButtonVariant } from '../../../atoms/button/button.component';
import { JoiiIcon } from '../../../icons/lucide/icon';
@Component({
  selector: 'joii-button-cell',
  template: `
    <button
      joii-button
      [variant]="variant()"
      [size]="size()"
      [loading]="loading()"
      [leadingIcon]="leadingIcon()"
      [trailingIcon]="trailingIcon()"
      (click)="onClick.emit()"
    >
      {{ value() }}
    </button>
  `,
  imports: [ButtonComponent],
  standalone: true,
})
export class ButtonCellComponent {
  variant = input<ButtonVariant>('primary');
  size = input<ButtonSize>('md');
  value = input<string>();
  onClick = output<void>();
  loading = input<boolean>(false);
  leadingIcon = input<JoiiIcon>();
  trailingIcon = input<JoiiIcon>();
}
